<template>
<div class="grid h-screen place-items-center ">
   <img class="z-999" :src="require('@/assets/Bird.gif')" alt="" />
  </div>
</template>

<script>
export default {};
</script>

<style  scoped>
.loading-box {
     position:fixed;
     background: rgb(254, 250, 250);
     box-shadow : 0px 0px -2px #000;
     z-index: 999;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid rgb(233, 129, 2);
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color:rgb(233, 129, 2) transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>